export default __webpack_public_path__ + "static/media/asssasas.0a3ec5be.png";